import Vue from 'vue';
import Router from 'vue-router';

import Authentication from './views/Authentication.vue';
import Dashboard from './views/Dashboard.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'authentication',
      component: Authentication,
    },
    {
      path: '/wachtwoord/:token',
      name: 'wachtwoord',
      component: () => import('./views/Wachtwoord.vue'),
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        label: 'Dashboard',
      },
    },
    {
      path: '/aansluitingen',
      name: 'aansluitingen',
      component: () => import('./views/Aansluitingen.vue'),
      meta: {
        label: 'Aansluitingen',
      },
    },
    {
      path: '/aansluiting/:aansluiting',
      name: 'aansluiting',
      component: () => import('./views/Itemdetail.vue'),
      meta: {
        label: 'Aansluiting details',
      },
    },
    {
      path: '/aanvragen',
      name: 'aanvragen',
      component: () => import('./views/Aanvragen.vue'),
      meta: {
        label: 'Aanvragen',
      },
    },
    {
      path: '/storingen',
      name: 'Storingen',
      component: () => import('./views/Storingen.vue'),
      meta: {
        label: 'Storingen',
      },
    },
    {
      path: '/onderhoud',
      name: 'Onderhoud',
      component: () => import('./views/Onderhoud.vue'),
      meta: {
        label: 'Onderhoud',
      },
    },
    {
      path: '/acties',
      name: 'acties',
      component: () => import('./views/acties.vue'),
      meta: {
        label: 'acties',
      },
    },
    {
      path: '/bedrijfsbeheer',
      name: 'Bedrijfsbeheer',
      component: () => import('./views/Bedrijfsbeheer.vue'),
      meta: {
        label: 'Bedrijfsbeheer',
      },
    },
    {
      path: '/profiel',
      name: 'Profiel',
      component: () => import('./views/Profiel.vue'),
      meta: {
        label: 'Profiel',
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});
